<template>
  <q-page padding class="row justify-center full-height full-width text-center">
  <div class="column flex-center text-center" v-if="!hasParameter">
    <div class="column flex-center text-center" v-if="!submited">
      <h5 class="q-my-none">Forgot Your Password?</h5>
      <p class="q-my-md">To reset your password, please enter your email address, We will send the password reset instructions to the email address for this account.. <br />
        If your email address is no longer valid, please <a href="https://climbicp.com.au/contact-new" target="blank">Contact Us</a> for further assistance.</p>
      <form @submit.prevent.stop="requestPasswordReset" @reset.prevent.stop="reset" class="q-gutter-y-md" style="width: 300px">
        <q-input v-model="email" type="email" label="Your Email"
                 class="q-pb-md" outlined
                 ref="emailInput"
                 lazy-rules
                 :rules="[ val => val && val.length > 0 && validateEmail(val) || 'Please enter a valid email address.' ]"/>
      <vue-recaptcha style="" @verify="verifyMethod"  @expired="expiredMethod" @error="errorMethod" sitekey="6LfhWgocAAAAAL0FEX8atlATav-a3TLtryz-wOA1">
</vue-recaptcha>                 
        <p v-show="registerError" class="text-red">
          {{registerErrorMessage}}
        </p>
        <q-btn type="submit" color="primary" class="full-width q-mx-md q-mt-sm q-mb-sm">Submit</q-btn>
      </form>
    </div>
    <div class="column flex-center text-center" v-if="submited">
      <h5 class="q-my-none">Request submitted</h5>
      <p class="q-my-md">We've emailed you a link to reset your password, if an account exists with the email you entered.</p>
      <p class="q-my-md">If you don't receive an email, please make sure you've entered the right email address and check your spam folder.</p>
    </div>  
  </div>
  <div class="column flex-center text-center" v-if="hasParameter">
    <div v-if="isValidFormat && isValid">
      <q-form @submit.prevent.stop="submitNewPassword" class="q-gutter-y-md" ref="passwordForm">
      <h5 class="q-my-md">New Password</h5>
      <div class="col" style="width: 280px"> 
        <q-input v-model="password" class="col-xs-12 col-sm-6" dense outlined label="Password" type="password"  autocomplete="new-password" lazy-rules :rules="[ val => val && val.length > 7 || 'Please enter a password of at least 8 characters.' ]"/>
        <q-input v-model="password2" class="col-xs-12 col-sm-6" dense outlined label="Repeat Password" type="password"  autocomplete="new-password" lazy-rules :rules="[ val => val && val == password || 'Does not match password above.' ]"/>
      </div>
      <q-btn type="submit" color="primary" class="full-width q-mx-md q-mt-sm q-mb-sm">Submit</q-btn>
      </q-form>
    </div>
    <div v-if="!isValid && !resetSuccessful && !resetFail">
      <h4>The password reset link is not valid or has expired, please try again.</h4>
    </div>
    <div v-if="resetSuccessful">
      <h4>Password changed successfully, redirecting you to the store.</h4>
    </div>
    <div v-if="resetFail">
      <h4>Not possible to change your password, please try again or  <a href="https://climbicp.com.au/contact-new" target="blank">Contact Us</a></h4>
    </div>
  </div>
  </q-page>
</template>

<script>
import gql from 'graphql-tag'
import { onLogin } from '../apollo/auth'
import VueRecaptcha from 'vue-recaptcha';

export default {
  name: 'ResetPassword',
  props: ['id'],
  components: { VueRecaptcha },
  data () {
    return {
      email: '',
      registerError: false,
      registerErrorMessage: '',
      submited: false,
      valid:false,
      password:'',
      password2:'',
      resetSuccessful: false,
      resetFail:false,
      captchaVerified: false
    }
  },
  computed:{
    hasParameter () {
      return !!this.$route.params.id;
    },
    isValid (){
      return this.valid
    },
    isValidFormat (){
      return this.validFormat();
    },
  },
  mounted() {
  let recaptchaScript = document.createElement('script')
  recaptchaScript.setAttribute('src', "https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit")
  document.head.appendChild(recaptchaScript)
  },  
  methods: {
    verifyMethod (response){
      this.captchaVerified = true;
      this.registerError = false,
      this.registerErrorMessage = '',
      console.log('RESPIBS',response);
    },
    expiredMethod (){
      this.captchaVerified = false;
    },
    errorMethod (e){
      this.captchaVerified = false;
      console.log('RECAPTCHA ERROR',e);  
    },
    reset () {
      this.email = ''
      this.clearFormError()
    },
    validateEmail (email) {
      // eslint-disable-next-line no-useless-escape
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(String(email).toLowerCase())
    },
    async submitNewPassword (){
      if(!this.validateNewPasswordForm()){
        return
      }
      
      try {
        let response = await this.$apollo.mutate({
          mutation: gql`
            mutation resetPassword($input: ResetPasswordInput!) {
              resetPassword(input: $input)
            }
          `,
          variables: {
            input: {
              uuid: this.$route.params.id,
              password: this.password
            }
          }
        })
        const token = response.data.resetPassword
        if(token != "false"){
          this.resetSuccessful = true;
          this.valid = false;
          await onLogin(this.$apollo, token)
          await this.$store.dispatch('auth/init')
          await this.$store.dispatch('cart/init')
          await this.$store.dispatch('filters/fetchProductColours')
          // eslint-disable-next-line no-undef
          analytics.track('Login')
          // this.reset()
          setTimeout(()=>{
            this.$router.push('/retail')
          },4000);
        }else{
          this.resetFail = true;
        }        
        // return response.data;
      } catch (ex) {
        console.log('error',ex);
        
      }   
    },
    validateForm () {
      this.$refs.emailInput.validate()
      return !(this.$refs.emailInput.hasError)
    },
    validateNewPasswordForm () {     
      return this.$refs.passwordForm.validate()
    },
    setFormError (message) {
      this.registerError = true
      this.registerErrorMessage = message
    },
    clearFormError () {
      this.registerError = false
      this.registerErrorMessage = ''
    },
    async validFormat (){
      const v4 = new RegExp(/^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i);
      this.valid = await this.validateUUID();
      return !!this.$route.params.id.match(v4);
    },
    async validateUUID(){ 
      try {
        let response = await this.$apollo.query({
          query: gql`
            query validateRequest($uuid: String!) {
              validateRequest(uuid: $uuid){
                uuid,
                accountId,
                valid
              }
            }
          `,
          variables: {
            uuid: this.$route.params.id
          }
        })
        return response.data.validateRequest.valid;
      } catch (ex) {
        console.log('error',ex);
        
      }      
    },
    async requestPasswordReset () {
      if (!this.validateForm()) {

        return
      }

      if(!this.captchaVerified){
      this.registerError = true
      this.registerErrorMessage = 'Please, click the verification box'
        return
      }

      try {               
        let result = await this.$store.$apollo.mutate({
          mutation: gql`
            mutation ($email: String!) {
              requestPasswordReset(email: $email)
          }`,
          variables: {
            email: this.email
          }
        })        
        this.submited = result.data.requestPasswordReset; 
      } catch (err) {
        console.log(err)
        if (err.networkError) {
          this.setFormError('Could not contact server')
        } else if (err.graphQLErrors && err.graphQLErrors.length) {
          this.setFormError(err.graphQLErrors[0].message)
        } else {
          this.setFormError('Error')
        }
      }
    }
  }
}
</script>
